import { imageMapper } from 'mappers/image/imageMapper';

import { ImageBlock } from './models';

export const imageBlockMapper = ({ caption, images }: ImageBlock) => ({
  ...(caption ? { caption } : undefined),
  images: images.map((image) => imageMapper(image)),
});
